import { BaseProviderInstanceResourceModel } from './base-provider-instance-resource-model';
import { ReportProfileAlertBaseModel } from './profile/report-profile-alert-base-model';

export class ReportProfileAlertResourcesBaseModel extends ReportProfileAlertBaseModel {
  providerInstanceResources: BaseProviderInstanceResourceModel[];
}
